import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { ContaService } from 'src/app/admihair/service/conta.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-operacao-financeira-inserir',
  templateUrl: './operacao-financeira-inserir.component.html',
  styleUrls: ['./operacao-financeira-inserir.component.scss']
})
export class OperacaoFinanceiraInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;

  isReceita: boolean = false;
  isDespesa: boolean = false;
  isInterno: boolean = false;
  listaContas: Conta[] = [];

  constructor(private operacaoService: OperacaoFinanceiraService,
    private contaService: ContaService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_OPERACAO_FINANCEIRA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.buscarContas();
    }
  }

  salvar() {
    this.progressoRequisicao = true;
    const operacao: Operacao = this.form?.value;
    operacao.empresaId = this.empresaSelecionada?.id
    this.operacaoService.salvar(operacao).subscribe({
      next: () => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.limparFormulario();

      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      }
    });
  }

  buscarContas() {
    this.contaService.listarPorEmpresa(this.empresaSelecionada?.id).subscribe({
      next: (data: Conta[]) => {
        this.listaContas = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
      }
    })
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  definirValoresFalso() {
    this.isReceita = false;
    this.isDespesa = false;
    this.isInterno = false;
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }

  limparFormulario() {
    this.form?.reset();
  }

  ocultarMsg() {
    this.messagemVisivel = false;
  }


}
